import "./NotificationModuleComponent.scss";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ButtonComponent from "../core/button/ButtonComponent";
import React, {useRef, useState, useCallback, useEffect} from "react";
import PopOversComponent from "../pop-overs/PopOversComponent";
import {CommonService} from "../../services";
import {Skeleton} from '@mui/material';
import moment from "moment";
import useFetch from "../../hooks/useFetch";
import {APIConfig} from "../../../constants";

interface NotificationModuleComponentProps {

}


interface Notification {
    id: number;
    from: number;
    to: number;
    message: string;
    url: string;
    isActive: boolean;
    createdBy: number;
    createdAt: string;
    updatedAt: string;
    toUserDetails: {
        id: number;
        firstName: string;
        lastName: string;
        middleName: string | null;
        dateOfBirth: string | null;
        gender: string | null;
        emailId: string;
        mobileNumber: string;
        roleObj: {
            id: number;
            title: string;
            code: string;
            isSdiRole: boolean;
            createdAt: string;
            updatedAt: string;
        };
    };
    fromUserDetails: {
        id: number;
        firstName: string;
        lastName: string;
        middleName: string | null;
        dateOfBirth: string | null;
        gender: string | null;
        emailId: string;
        mobileNumber: string;
        roleObj: {
            id: number;
            title: string;
            code: string;
            isSdiRole: boolean;
            createdAt: string;
            updatedAt: string;
        };
    };
}

const nameShortner = (fullName: string) => {
    const nameParts = fullName?.trim()?.split(' ');

    // If there's only one part, return just the first letter
    if (nameParts?.length === 1) {
        return nameParts?.[0]?.charAt(0)?.toUpperCase();
    }

    // Take the first letter of the first and last name parts
    const firstInitial = nameParts?.[0]?.charAt(0)?.toUpperCase();
    const lastInitial = nameParts?.[nameParts?.length - 1]
        ?.charAt(0)
        ?.toUpperCase();

    return firstInitial + lastInitial;
}


const NotificationModuleComponent = (props: NotificationModuleComponentProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
    const {
        response: notificationList = [],
        loading: isNotificationLoading,
        // loadingFailed: isNotificationFailed,
        fetchData: fetchNotification,
    } = useFetch<Notification[]>();

    const getNotificationList = useCallback(() => {
        fetchNotification({
            url: APIConfig.GET_NOTIFICATION_LIST.URL,
            method: APIConfig.GET_NOTIFICATION_LIST.METHOD,
        })
    }, [fetchNotification])
    const onOpenNotification = useCallback(() => {
        setIsOpen(true);
    }, [])
    const onCloseNotification = useCallback(() => {
        setIsOpen(false);
    }, [])

    useEffect(() => {
        getNotificationList();
    }, [getNotificationList]);
    useEffect(() => {
        console.log({notificationList})
    }, [notificationList]);
    return (
        <div className={'notification-module-component'}>
            <div ref={ref} className="notification-action-button">
                <ButtonComponent
                    handleClick={onOpenNotification}
                    variant={'icon'}>
                    {/*<Badge badgeContent={notificationList?.length} color="primary"*/}
                    {/*       anchorOrigin={{*/}
                    {/*           vertical: 'top',*/}
                    {/*           horizontal: 'right',*/}
                    {/*       }}*/}
                    {/*>*/}
                    <NotificationsActiveIcon/>
                    {/*</Badge>*/}
                </ButtonComponent>
            </div>
            <PopOversComponent
                isOpen={isOpen}
                className={"notification-modal-container"}
                anchorEl={ref.current}
                onClose={onCloseNotification}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
            >
                <div className="notification-header">
                    <div className="notification-header-title">
                        Notifications
                    </div>
                </div>
                <div className="notification-body">
                    {!isNotificationLoading && notificationList?.map((notification) => (
                        <div key={notification.id}
                             className={`notification-item ${notification.isActive ? '' : 'unread'}`}>
                            <div className="notification-avatar">
                                {nameShortner(notification?.fromUserDetails?.firstName + " " + notification?.fromUserDetails?.lastName)}
                            </div>
                            <div className="notification-content">
                                <div
                                    className="notification-title">{notification?.fromUserDetails?.firstName + " " + notification?.fromUserDetails?.lastName}</div>
                                <div className="notification-message">{notification.message}</div>
                                {/*<div className="notification-type">{notification.type}</div>*/}
                                {/*<div*/}
                                {/*    className="notification-time">{CommonService.formatTime(notification.timestamp)}</div>*/}
                                <div
                                    className="notification-time">
                                    <section
                                        title={CommonService.formatTime(notification.createdAt, 'DD-MMM-YYYY hh:mm A')}>
                                        {moment(notification.createdAt).fromNow()}
                                    </section>
                                </div>
                            </div>
                        </div>
                    ))}
                    {
                        notificationList?.length === 0 && !isNotificationLoading && (
                            <div className={'notification-empty-state'}>
                                No notifications found
                            </div>
                        )
                    }
                    {
                        isNotificationLoading && (
                            Array.from({length: 5}).map(() => {
                                return <Skeleton animation="wave" className={"notification-item"}
                                                 variant={'rectangular'}
                                                 width={"100%"}
                                                 height={93}/>
                            })
                        )
                    }
                    {/*{notificationList && notificationList?.length > 0 && <div className={'d-flex justify-content-center'}>*/}
                    {/*    <ButtonComponent variant={'text'}>Load More</ButtonComponent>*/}
                    {/*</div>}*/}
                </div>
                {/*<div className="notification-footer">*/}
                {/*    <ButtonComponent*/}
                {/*        variant={'text'}*/}
                {/*        handleClick={() => {*/}
                {/*            console.log('Mark all as read')*/}
                {/*        }}>*/}
                {/*        Mark all as read*/}
                {/*    </ButtonComponent>*/}
                {/*    <ButtonComponent*/}
                {/*        variant={'text'}*/}
                {/*        handleClick={() => {*/}
                {/*            console.log('Dismiss all')*/}
                {/*        }}>*/}
                {/*        Dismiss all*/}
                {/*    </ButtonComponent>*/}
                {/*    <ButtonComponent*/}
                {/*        variant={'text'}*/}
                {/*        handleClick={() => {*/}
                {/*            console.log('View all')*/}
                {/*        }}>*/}
                {/*        View all*/}
                {/*    </ButtonComponent>*/}
                {/*</div>*/}
            </PopOversComponent>
        </div>
    );

};

export default NotificationModuleComponent;
